import { Component, Injector, Input } from '@angular/core';
import { SelectableOption, Stylable } from '../base-types';
import { IconSettings } from '../icon/icon.component';

/**
 * Rappresenta il modello di una Tile.
 * NOTA: si è dato il suffisso 'model' anche per disambiguare rispetto ad un potenziale componente Tile (al momento esiste solo il TileSet)
 */
export interface TileModel extends SelectableOption{
  imageUrl?: string;
  navigable?: boolean;
  action?: Function;
  requiredAuthorities?: string[];
  label2?: string,
  shortLabel2?: string,
  label3?: string,
  shortLabel3?: string,
}

export interface TileSettings extends Stylable{
  image?: Stylable,
  icon?: IconSettings,
  label?: Stylable,
  label2?: Stylable,
  label3?: Stylable,
}

export interface TileSetSettings extends Stylable {
  layout?: 0|1|2|3,
  spacing?: string,
  tileSettings?: TileSettings,
  hoverTileSettings?: TileSettings,
  selectedTileSettings?: TileSettings,
  alignment?: 'start'|'center'|'end'
}

@Component({
  selector: 'app-tile-set',
  templateUrl: './tile-set.component.html',
  styleUrls: ['./tile-set.component.scss']
})
export class TileSetComponent {
 
  @Input() tiles: TileModel[]

  @Input() set settings(_settings: TileSetSettings){
    this._initSettings(_settings)
  }
  get settings(){
    return this._settings;
  }
  _settings: TileSetSettings
  
  hoverId: string|number;
  selectedId: string|number;

  constructor(protected _injector: Injector) {
    this._initSettings();
  }

  public select(tileId: string|number){
    this.selectedId = tileId;
  }

  public hover(tileId: string|number){
    this.hoverId = tileId;
  }

  public unhover(){
    this.hoverId = null;
  }

  private _initSettings(settings?: TileSetSettings){
    const _settings = JSON.parse(JSON.stringify(settings||{}))

    _settings.layout = _settings.layout || 0;
    _settings.width = _settings.width || '100%';
    _settings.alignment = _settings.alignment || 'center';
    _settings.spacing = _settings.spacing || '4px';
    _settings.tileSettings = _settings.tileSettings || {}
    _settings.tileSettings.border = _settings.tileSettings.border || '1px solid black';
    _settings.tileSettings.padding = _settings.tileSettings.padding || '0';
    _settings.tileSettings.fontColor = _settings.tileSettings.fontColor || 'black';
    _settings.tileSettings.icon = _settings.tileSettings.icon || {};
    _settings.tileSettings.image = _settings.tileSettings.image || {};
    _settings.tileSettings.label = _settings.tileSettings.label || {};
    _settings.tileSettings.label2 = _settings.tileSettings.label2 || {};
    _settings.tileSettings.label3 = _settings.tileSettings.label3 || {};

    _settings.hoverTileSettings = _settings.hoverTileSettings || JSON.parse(JSON.stringify(_settings.tileSettings))
    _settings.selectedTileSettings = _settings.hoverTileSettings || JSON.parse(JSON.stringify(_settings.tileSettings))
    
    this._settings = _settings
  }
}
